export const TILES_EXISTING_COL_IDX_KEBAB = 0;
export const COL_IDX_ICON = 1;
export const COL_IDX_NAME = 2;
export const COL_IDX_TAGS = 3;
export const COL_IDX_CURRENT_VALUE = 4;
export const COL_IDX_BUTTONS = 5;
export const COL_IDX_ID = 6;
